<mat-card class="card-class" (click)="openCardModal()" >
    <mat-card-content class="wrap">{{card.text}}</mat-card-content>
    <mat-card-content>
        <p>{{votes ? votes.length : null}}</p> <mat-icon class="icon click-icon plusOne" inline="true" matPrefix (click)="vote()">plus_one</mat-icon>
        <p>{{comments ? comments.length : null}}</p> <mat-icon class="icon click-icon comment" inline="true" matPrefix (click)="openCardModal()">comment</mat-icon>
    </mat-card-content>
</mat-card>
